import BaseReduction from './BaseReduction';

export default class OwnReduction extends BaseReduction {
  constructor() {
    super(...arguments);
    this.ensureInteger('minPlayworthyRow', -1);
    this.ensureInteger('maxOverplayedHorses', -1);
    this.ensureInteger('minOverplayedHorses', -1);
    this.ensureInteger('maxUnderplayedHorses', -1);
    this.ensureInteger('minUnderplayedHorses', -1);
    this.ensureInteger('minMostUnderplayedHorses', -1);
    this.ensureInteger('maxMostOverplayedHorses', -1);
  }

  isEmpty() {
    if (this.getMinPlayworthyRow() > 0) {
      return false;
    }

    if (
      this.getMinOverplayedHorses() >= 0 ||
      this.getMaxOverplayedHorses() >= 0
    ) {
      return false;
    }

    if (
      this.getMinUnderplayedHorses() >= 0 ||
      this.getMaxUnderplayedHorses() >= 0
    ) {
      return false;
    }

    if (this.getMinMostUnderplayedHorses() >= 0) {
      return false;
    }

    if (this.getMaxMostOverplayedHorses() >= 0) {
      return false;
    }

    return true;
  }

  /* Bet distribution */
  getMinPlayworthyRow() {
    return this.getInteger('minPlayworthyRow', -1);
  }

  setMinPlayworthyRow(v) {
    this.invalidate();
    return this.setInteger('minPlayworthyRow', v);
  }

  /* Overplayed  */
  getMaxOverplayedHorses() {
    return this.getInteger('maxOverplayedHorses', -1);
  }

  getMinOverplayedHorses() {
    return this.getInteger('minOverplayedHorses', -1);
  }

  setMaxOverplayedHorses(v) {
    this.invalidate();
    return this.setInteger('maxOverplayedHorses', v);
  }

  setMinOverplayedHorses(v) {
    this.invalidate();
    return this.setInteger('minOverplayedHorses', v);
  }

  /* Underplayed */
  getMaxUnderplayedHorses() {
    return this.getInteger('maxUnderplayedHorses', -1);
  }

  getMinUnderplayedHorses() {
    return this.getInteger('minUnderplayedHorses', -1);
  }

  setMaxUnderplayedHorses(v) {
    this.invalidate();
    return this.setInteger('maxUnderplayedHorses', v);
  }

  setMinUnderplayedHorses(v) {
    this.invalidate();
    return this.setInteger('minUnderplayedHorses', v);
  }

  /* Underplayed Must Win */
  getMinMostUnderplayedHorses() {
    return this.getInteger('minMostUnderplayedHorses', -1);
  }

  setMinMostUnderplayedHorses(v) {
    this.invalidate();
    return this.setInteger('minMostUnderplayedHorses', v);
  }

  /* Overplayed Must Win */
  getMaxMostOverplayedHorses() {
    return this.getInteger('maxMostOverplayedHorses', -1);
  }

  setMaxMostOverplayedHorses(v) {
    this.invalidate();
    return this.setInteger('maxMostOverplayedHorses', v);
  }
}
